export const productsData = {
  "software-solutions": {
    "slug": "software-solutions",
    "title": "Enterprise CRM & ERP Suite",
    "heroIcon": "fa fa-desktop",
    "heroBg": "/assets/img/unsplash-1542621334-a254cf47733d.jpg",
    "overview": {
      "subtitle": "Modules & Specs",
      "title": "Products",
      "desc": "Streamline your business workflows, track sales pipelines, manage HR & payroll, and generate automated financial reports with our custom, ready-to-deploy CRM/ERP software tailored for Bangladesh and whole worldbusinesses.",
      "checklist": [
        "Website Packages",
        "E-Commerce Packages",
        "Software Development Packages",
        "Hosting Packages"
      ]
    },
    "subServices": {
      "subtitle": "Modules & Specs",
      "title": "Product Capabilities",
      "items": [
        {
          "icon": "fa fa-building",
          "title": "Enterprise Resource Planning (ERP)",
          "desc": "Integrated management of core business processes."
        },
        {
          "icon": "fa fa-users",
          "title": "Customer Relationship Management (CRM)",
          "desc": "Manage company relationships and interactions with customers."
        },
        {
          "icon": "fa fa-user-tie",
          "title": "Human Resources Management (HRMS)",
          "desc": "End-to-end employee management and HR workflows."
        },
        {
          "icon": "fa fa-money-check-alt",
          "title": "Payroll Management System",
          "desc": "Automated salary calculations, tax deductions, and payouts."
        },
        {
          "icon": "fa fa-cash-register",
          "title": "Point of Sale (POS) Systems",
          "desc": "Modern billing, invoicing, and sales tracking for retail."
        },
        {
          "icon": "fa fa-shopping-cart",
          "title": "E-Commerce Platforms",
          "desc": "Complete online store solutions with payment integrations."
        },
        {
          "icon": "fa fa-school",
          "title": "School Management System",
          "desc": "Digital administration for schools, students, and academics."
        },
        {
          "icon": "fa fa-hospital",
          "title": "Hospital Management System",
          "desc": "Smart healthcare management for patients and wards."
        },
        {
          "icon": "fa fa-boxes",
          "title": "Inventory Management System",
          "desc": "Real-time stock control and inventory tracking."
        },
        {
          "icon": "fa fa-warehouse",
          "title": "Warehouse Management (WMS)",
          "desc": "Optimize warehouse operations and supply chain logistics."
        },
        {
          "icon": "fa fa-file-invoice-dollar",
          "title": "Accounting & Finance Software",
          "desc": "Ledgers, bookkeeping, and automated financial reporting."
        },
        {
          "icon": "fa fa-truck-moving",
          "title": "Supply Chain Management",
          "desc": "End-to-end visibility and control of your supply chain."
        },
        {
          "icon": "fa fa-car-side",
          "title": "Fleet Management System",
          "desc": "Vehicle tracking, maintenance scheduling, and route optimization."
        },
        {
          "icon": "fa fa-city",
          "title": "Real Estate Management",
          "desc": "Manage properties, tenants, and real estate sales pipelines."
        },
        {
          "icon": "fa fa-building",
          "title": "Property Management (PMS)",
          "desc": "Automated rent collection, maintenance requests, and leases."
        },
        {
          "icon": "fa fa-hotel",
          "title": "Hotel Booking & Management",
          "desc": "Room reservations, guest services, and housekeeping."
        },
        {
          "icon": "fa fa-utensils",
          "title": "Restaurant Management POS",
          "desc": "Table management, KDS, and restaurant billing."
        },
        {
          "icon": "fa fa-laptop-code",
          "title": "Learning Management System",
          "desc": "Online courses, student progress tracking, and e-learning."
        },
        {
          "icon": "fa fa-stethoscope",
          "title": "Clinic Management System",
          "desc": "Doctor appointments, prescriptions, and patient records."
        },
        {
          "icon": "fa fa-pills",
          "title": "Pharmacy Management System",
          "desc": "Medicine inventory, expiry tracking, and billing."
        },
        {
          "icon": "fa fa-microscope",
          "title": "Laboratory Management (LIMS)",
          "desc": "Lab testing workflows, sample tracking, and reports."
        },
        {
          "icon": "fa fa-industry",
          "title": "Manufacturing Execution (MES)",
          "desc": "Track and document the transformation of raw materials."
        },
        {
          "icon": "fa fa-chart-line",
          "title": "Lead Tracking Software",
          "desc": "Capture, qualify, and convert sales leads efficiently."
        },
        {
          "icon": "fa fa-ticket-alt",
          "title": "Support Ticketing System",
          "desc": "Helpdesk solution for managing customer support requests."
        },
        {
          "icon": "fa fa-tasks",
          "title": "Task & Project Management",
          "desc": "Agile task tracking, milestones, and team collaboration."
        },
        {
          "icon": "fa fa-folder-open",
          "title": "Document Management (DMS)",
          "desc": "Secure document storage, versioning, and sharing."
        },
        {
          "icon": "fa fa-barcode",
          "title": "Asset Management Software",
          "desc": "Track depreciation, maintenance, and location of assets."
        },
        {
          "icon": "fa fa-shopping-basket",
          "title": "Procurement Management",
          "desc": "Purchase orders, vendor quotes, and requisition workflows."
        },
        {
          "icon": "fa fa-plane",
          "title": "Travel Agency System",
          "desc": "Tour packages, itinerary planning, and booking management."
        },
        {
          "icon": "fa fa-calendar-alt",
          "title": "Event Management Software",
          "desc": "Ticketing, attendee registration, and event scheduling."
        },
        {
          "icon": "fa fa-dumbbell",
          "title": "Gym & Fitness Management",
          "desc": "Member subscriptions, class scheduling, and access control."
        },
        {
          "icon": "fa fa-spa",
          "title": "Salon & Spa Management",
          "desc": "Stylist appointments, service packages, and POS."
        },
        {
          "icon": "fa fa-car",
          "title": "Car Rental System",
          "desc": "Vehicle reservations, fleet tracking, and rental billing."
        },
        {
          "icon": "fa fa-car-crash",
          "title": "Dealership Management",
          "desc": "Vehicle sales, service history, and spare parts inventory."
        },
        {
          "icon": "fa fa-wrench",
          "title": "Auto Repair Shop Software",
          "desc": "Job cards, mechanic scheduling, and invoicing."
        },
        {
          "icon": "fa fa-taxi",
          "title": "Taxi Dispatch System",
          "desc": "Ride booking, driver apps, and automated dispatch."
        },
        {
          "icon": "fa fa-ship",
          "title": "Freight Forwarding Software",
          "desc": "Shipping logistics, customs documentation, and tracking."
        },
        {
          "icon": "fa fa-box-open",
          "title": "Courier & Logistics System",
          "desc": "Parcel tracking, delivery routing, and dispatch management."
        },
        {
          "icon": "fa fa-gavel",
          "title": "Legal Case Management",
          "desc": "Law firm practice management, case files, and billing."
        },
        {
          "icon": "fa fa-hard-hat",
          "title": "Construction Management",
          "desc": "Project estimation, contractor management, and progress tracking."
        },
        {
          "icon": "fa fa-tractor",
          "title": "Agriculture & Farm Management",
          "desc": "Crop planning, yield tracking, and farm inventory."
        },
        {
          "icon": "fa fa-tshirt",
          "title": "Laundry Management System",
          "desc": "Garment tracking, POS, and delivery scheduling."
        },
        {
          "icon": "fa fa-bread-slice",
          "title": "Bakery & Cafe POS",
          "desc": "Recipe management, quick billing, and ingredient tracking."
        },
        {
          "icon": "fa fa-id-card",
          "title": "Membership Management",
          "desc": "Club memberships, dues collection, and member portals."
        },
        {
          "icon": "fa fa-edit",
          "title": "Online Examination Platform",
          "desc": "Secure computer-based testing and automated grading."
        },
        {
          "icon": "fa fa-clock",
          "title": "Attendance & Time Tracking",
          "desc": "Biometric integration and employee shift management."
        },
        {
          "icon": "fa fa-calendar-times",
          "title": "Leave Management System",
          "desc": "Employee time-off requests and approval workflows."
        },
        {
          "icon": "fa fa-receipt",
          "title": "Expense Management System",
          "desc": "Corporate expense reporting and reimbursement workflows."
        },
        {
          "icon": "fa fa-poll",
          "title": "Customer Feedback & Survey",
          "desc": "NPS surveys, customer reviews, and feedback analytics."
        },
        {
          "icon": "fa fa-gift",
          "title": "Loyalty Program Management",
          "desc": "Points accumulation, rewards redemption, and gift cards."
        },
        {
          "icon": "fa fa-calendar-check",
          "title": "Appointment Scheduling",
          "desc": "Online booking calendar for services and consultations."
        },
        {
          "icon": "fa fa-store-alt",
          "title": "B2B Wholesale Ordering",
          "desc": "Bulk ordering portal for distributors and wholesalers."
        },
        {
          "icon": "fa fa-handshake",
          "title": "Vendor Management System",
          "desc": "Supplier onboarding, performance tracking, and contracts."
        },
        {
          "icon": "fa fa-chart-pie",
          "title": "Business Intelligence (BI)",
          "desc": "Data visualization, analytics, and custom KPI dashboards."
        },
        {
          "icon": "fa fa-bullhorn",
          "title": "Marketing Automation",
          "desc": "Email campaigns, lead nurturing, and marketing analytics."
        },
        {
          "icon": "fa fa-share-alt",
          "title": "Social Media Management",
          "desc": "Post scheduling, engagement tracking, and analytics."
        },
        {
          "icon": "fa fa-network-wired",
          "title": "IT Asset Management",
          "desc": "Hardware/software inventory and license tracking."
        },
        {
          "icon": "fa fa-database",
          "title": "Data Backup & Recovery",
          "desc": "Automated cloud backups and disaster recovery solutions."
        },
        {
          "icon": "fa fa-cloud-upload-alt",
          "title": "Cloud Storage & Sharing",
          "desc": "Secure file hosting and collaborative workspaces."
        },
        {
          "icon": "fa fa-project-diagram",
          "title": "Workflow Automation",
          "desc": "Custom digital workflows to replace manual paper processes."
        },
        {
          "icon": "fa fa-shopping-cart",
          "title": "E-Procurement Software",
          "desc": "Digital sourcing, bidding, and auction management."
        },
        {
          "icon": "fa fa-file-signature",
          "title": "Contract Management",
          "desc": "Digital signatures, contract lifecycle, and renewals."
        },
        {
          "icon": "fa fa-notes-medical",
          "title": "Electronic Medical Records (EMR)",
          "desc": "Digital patient charts and medical history tracking."
        },
        {
          "icon": "fa fa-user-md",
          "title": "Patient Portal Software",
          "desc": "Secure portal for patients to view results and message doctors."
        },
        {
          "icon": "fa fa-video",
          "title": "Telemedicine Platform",
          "desc": "Virtual video consultations and remote patient monitoring."
        },
        {
          "icon": "fa fa-tooth",
          "title": "Dental Clinic Management",
          "desc": "Odontograms, dental appointments, and treatment plans."
        },
        {
          "icon": "fa fa-glasses",
          "title": "Optical Store Management",
          "desc": "Eye prescriptions, lens inventory, and POS."
        },
        {
          "icon": "fa fa-paw",
          "title": "Veterinary Practice System",
          "desc": "Pet medical records, vaccination reminders, and billing."
        },
        {
          "icon": "fa fa-church",
          "title": "Church Management Software",
          "desc": "Congregation management, donations, and event planning."
        },
        {
          "icon": "fa fa-hands-helping",
          "title": "Charity & NGO Management",
          "desc": "Donor management, fundraising campaigns, and grant tracking."
        },
        {
          "icon": "fa fa-address-card",
          "title": "Visitor Management System",
          "desc": "Digital lobby check-in, badges, and security logs."
        },
        {
          "icon": "fa fa-user-check",
          "title": "Applicant Tracking (ATS)",
          "desc": "Job postings, resume parsing, and interview scheduling."
        },
        {
          "icon": "fa fa-store",
          "title": "B2C Marketplace Platform",
          "desc": "Multi-vendor e-commerce marketplace infrastructure."
        },
        {
          "icon": "fa fa-sync-alt",
          "title": "Subscription Billing",
          "desc": "Recurring payments, subscription tiers, and invoicing."
        },
        {
          "icon": "fa fa-book",
          "title": "Knowledge Base Platform",
          "desc": "Self-service documentation and FAQ management."
        },
        {
          "icon": "fa fa-map-marked-alt",
          "title": "Field Service Management",
          "desc": "Technician dispatch, mobile work orders, and GPS tracking."
        },
        {
          "icon": "fa fa-tools",
          "title": "Facilities Management",
          "desc": "Building maintenance, space planning, and work orders."
        },
        {
          "icon": "fa fa-check-double",
          "title": "Quality Control System",
          "desc": "Inspection checklists, defect tracking, and compliance."
        },
        {
          "icon": "fa fa-info-circle",
          "title": "Product Information (PIM)",
          "desc": "Centralized management of product catalogs and specs."
        },
        {
          "icon": "fa fa-robot",
          "title": "AI Chatbot & Assistant",
          "desc": "Automated customer service and intelligent inquiry handling."
        }
      ]
    }
  },
  "infrastructure-servers": {
    "slug": "infrastructure-servers",
    "title": "High-Performance VPS Clusters",
    "heroIcon": "fa fa-server",
    "heroBg": "/assets/img/unsplash-1454165804606-c3d57bc86b40.jpg",
    "overview": {
      "subtitle": "Modules & Specs",
      "title": "Product Capabilities",
      "desc": "Deploy your critical business applications, portals, and database setups on our high-performance, enterprise-grade virtual server clusters backed by SSD NVMe storage and dedicated support.",
      "checklist": [
        "Isolated Dedicated Virtual Resources (CPU, RAM, Storage)",
        "Enterprise NVMe SSD RAID storage arrays for maximum IOPS",
        "Automated daily offsite backup snapshots with 1-click restore",
        "Built-in Layer 3/4/7 DDoS mitigation and custom firewall rules",
        "99.99% Network Uptime Guarantee backed by corporate SLA"
      ]
    },
    "subServices": {
      "subtitle": "Modules & Specs",
      "title": "Product Capabilities",
      "items": [
        {
          "icon": "fa fa-hdd",
          "title": "Managed VPS Starter",
          "desc": "Ideal for growing portals and static corporate websites requiring dedicated hosting resources."
        },
        {
          "icon": "fa fa-microchip",
          "title": "Business Dedicated",
          "desc": "High-performance dedicated virtual nodes designed for large databases and high-traffic e-commerce."
        },
        {
          "icon": "fa fa-network-wired",
          "title": "High-Availability Cluster",
          "desc": "Load-balanced multi-server clusters configured with automated failover and database replication."
        },
        {
          "icon": "fa fa-shield-alt",
          "title": "Security & WAF Shield",
          "desc": "Managed web application firewall configurations and secure isolated networks (VPC)."
        }
      ]
    }
  },
  "cloud-saas-product": {
    "slug": "cloud-saas-product",
    "title": "AWS Managed Subscriptions",
    "heroIcon": "fa fa-cloud",
    "heroBg": "/assets/img/unsplash-1504384308090-c894fdcc538d.jpg",
    "overview": {
      "subtitle": "Modules & Specs",
      "title": "Product Capabilities",
      "desc": "Deploy highly scalable, audited AWS cloud environments using our pre-built, cost-optimized system architecture blueprints without the overhead of custom cloud engineering.",
      "checklist": [
        "Pre-configured AWS EC2, S3, RDS, and CloudFront CDN stacks",
        "Serverless Application Stack (AWS Lambda & API Gateway integration)",
        "Built-in Auto-scaling parameters to handle massive traffic spikes",
        "Advanced CloudWatch Alerting Dashboards for system performance",
        "Ongoing Monthly Cloud Cost Auditing to minimize monthly billing"
      ]
    },
    "subServices": {
      "subtitle": "Modules & Specs",
      "title": "Product Capabilities",
      "items": [
        {
          "icon": "fa fa-server",
          "title": "AWS EC2 & RDS Stack",
          "desc": "Pre-packaged virtual machines and fully-managed database blueprints with automatic daily backups."
        },
        {
          "icon": "fa fa-bolt",
          "title": "Serverless Cloud Stack",
          "desc": "Maximize efficiency with serverless execution models for REST APIs, notifications, and microservices."
        },
        {
          "icon": "fa fa-globe",
          "title": "AWS CloudFront CDN",
          "desc": "Deliver global assets with low latency via edge routing and pre-configured caching strategies."
        },
        {
          "icon": "fa fa-heartbeat",
          "title": "Ops Monitoring Shield",
          "desc": "Real-time performance alert setups for database query times, CPU utilization, and error rates."
        }
      ]
    }
  },
  "website-packages": {
    "slug": "website-packages",
    "title": "Website Packages",
    "heroIcon": "fa fa-laptop",
    "heroBg": "/assets/img/unsplash-1542621334-a254cf47733d.jpg",
    "overview": {
      "subtitle": "Packages",
      "title": "Website Packages Overview",
      "desc": "Explore our comprehensive website packages tailored to establish and grow your digital presence.",
      "checklist": [
        "Responsive & Mobile-Friendly Design",
        "SEO Optimized Architecture",
        "Secure & Fast Loading",
        "Custom Content Management",
        "Dedicated Support"
      ]
    },
    "subServices": {
      "subtitle": "Features",
      "title": "What's Included",
      "items": [
        {
          "icon": "fa fa-paper-plane",
          "title": "Starter / Basic Website",
          "desc": "Perfect for small businesses. A 1-5 page professional online presence with contact forms and mobile optimization."
        },
        {
          "icon": "fa fa-building",
          "title": "Corporate & Business Website",
          "desc": "Up to 15+ pages with a robust Content Management System (CMS), SEO architecture, and blog integration."
        },
        {
          "icon": "fa fa-shopping-cart",
          "title": "E-Commerce Web Store",
          "desc": "Fully functional online store with product catalogs, secure payment gateways, and inventory management."
        },
        {
          "icon": "fa fa-bullseye",
          "title": "Campaign Landing Page",
          "desc": "High-converting, single-page designs optimized for marketing campaigns, lead generation, and fast loading."
        },
        {
          "icon": "fa fa-laptop-code",
          "title": "Custom Web Application",
          "desc": "Complex logic, custom databases, user portals, and API integrations tailored entirely to your unique workflow."
        }
      ]
    }
  },
  "e-commerce-packages": {
    "slug": "e-commerce-packages",
    "title": "E-Commerce Packages",
    "heroIcon": "fa fa-shopping-cart",
    "heroBg": "/assets/img/unsplash-1454165804606-c3d57bc86b40.jpg",
    "overview": {
      "subtitle": "Packages",
      "title": "E-Commerce Packages Overview",
      "desc": "Launch your online store with our robust e-commerce packages, designed for scalability and high conversion rates.",
      "checklist": [
        "Secure Payment Gateways",
        "Inventory Management",
        "Mobile-Optimized Shopping",
        "Customer Account Dashboards",
        "Automated Order Processing"
      ]
    },
    "subServices": {
      "subtitle": "Features",
      "title": "What's Included",
      "items": [
        {
          "icon": "fa fa-store",
          "title": "Standard E-Commerce Store",
          "desc": "Perfect for small to medium retailers. Includes product catalogs, cart, checkout, and inventory management for up to 500 products."
        },
        {
          "icon": "fa fa-users",
          "title": "Multi-Vendor Marketplace",
          "desc": "Create a platform like Amazon where multiple independent sellers can register, manage their own shops, and earn commissions."
        },
        {
          "icon": "fa fa-industry",
          "title": "B2B Wholesale Portal",
          "desc": "Designed for bulk buyers with custom pricing tiers, bulk order forms, account approvals, and minimum order quantities."
        },
        {
          "icon": "fa fa-sync-alt",
          "title": "Subscription Box Platform",
          "desc": "Built for recurring revenue. Features subscription billing, member dashboards, and automated scheduled delivery systems."
        },
        {
          "icon": "fa fa-box-open",
          "title": "Dropshipping Automation Setup",
          "desc": "Fully automated stores with direct supplier integrations, real-time inventory syncing, and dynamic pricing rules."
        }
      ]
    }
  },
  "software-development-packages": {
    "slug": "software-development-packages",
    "title": "Software Development Packages",
    "heroIcon": "fa fa-cogs",
    "heroBg": "/assets/img/unsplash-1504384308090-c894fdcc538d.jpg",
    "overview": {
      "subtitle": "Packages",
      "title": "Software Development Overview",
      "desc": "Custom software solutions engineered to automate your workflows, improve efficiency, and scale with your business.",
      "checklist": [
        "Custom API Integrations",
        "Scalable Cloud Architecture",
        "Agile Development Process",
        "Rigorous Quality Assurance",
        "Long-term Maintenance"
      ]
    },
    "subServices": {
      "subtitle": "Features",
      "title": "What's Included",
      "items": [
        {
          "icon": "fa fa-rocket",
          "title": "Startup MVP Development",
          "desc": "Rapid prototyping and Minimum Viable Product (MVP) builds to quickly launch your idea to market and test with real users."
        },
        {
          "icon": "fa fa-building",
          "title": "Custom Enterprise Software",
          "desc": "Full-scale custom ERP, CRM, and internal portal development tailored to your organization's complex operational workflows."
        },
        {
          "icon": "fa fa-mobile-alt",
          "title": "Mobile App Development",
          "desc": "High-performance native and cross-platform mobile applications for both iOS and Android ecosystems."
        },
        {
          "icon": "fa fa-sync",
          "title": "Legacy System Modernization",
          "desc": "Upgrade outdated, legacy software architecture to modern, scalable, and secure cloud-native stacks."
        },
        {
          "icon": "fa fa-plug",
          "title": "API Development & Integration",
          "desc": "Secure REST/GraphQL endpoint development and seamless third-party software integrations to connect your digital ecosystem."
        }
      ]
    }
  },
  "hosting-packages": {
    "slug": "hosting-packages",
    "title": "Hosting Packages",
    "heroIcon": "fa fa-server",
    "heroBg": "/assets/img/unsplash-1503437313881-503a91226402.jpg",
    "overview": {
      "subtitle": "Packages",
      "title": "Hosting Packages Overview",
      "desc": "Reliable, high-performance hosting solutions providing the speed, security, and uptime your digital assets require.",
      "checklist": [
        "99.9% Uptime Guarantee",
        "Daily Automated Backups",
        "Free SSL Certificates",
        "24/7 Server Monitoring",
        "DDoS Protection"
      ]
    },
    "subServices": {
      "subtitle": "Features",
      "title": "What's Included",
      "items": [
        {
          "icon": "fa fa-hdd",
          "title": "Shared Web Hosting",
          "desc": "Cost-effective hosting perfect for small businesses and personal blogs, featuring easy control panels and 1-click installs."
        },
        {
          "icon": "fab fa-wordpress",
          "title": "Managed WordPress Hosting",
          "desc": "Optimized specifically for WordPress with automatic updates, daily backups, and enhanced caching for maximum speed."
        },
        {
          "icon": "fa fa-server",
          "title": "Virtual Private Server (VPS)",
          "desc": "Scalable, dedicated virtual resources offering root access and isolated environments for growing applications."
        },
        {
          "icon": "fa fa-database",
          "title": "Dedicated Server Hosting",
          "desc": "The ultimate performance solution providing complete control over a physical server for high-traffic and resource-intensive sites."
        },
        {
          "icon": "fa fa-cloud",
          "title": "Cloud Hosting Clusters",
          "desc": "High-availability cloud infrastructure with auto-scaling capabilities to handle sudden traffic spikes without downtime."
        }
      ]
    }
  }
};
